import { render } from "./create-meter-opportunity.vue?vue&type=template&id=5565a980&scoped=true"
import script from "./create-meter-opportunity.vue?vue&type=script&lang=js"
export * from "./create-meter-opportunity.vue?vue&type=script&lang=js"

import "./create-meter-opportunity.vue?vue&type=style&index=0&id=5565a980&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5565a980"]])

export default __exports__